import { IMAGES } from "@/lib/site";

export const Proof = () => (
  <section className="border-b border-white/10 bg-[#0c1220] py-20" data-testid="proof-section">
    <div className="mx-auto max-w-4xl px-6 text-center">
      <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-full border border-white/10 bg-white/5 text-[#38bdf8]">
        <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
        </svg>
      </div>
      <h3 className="mb-3 font-disp text-2xl uppercase text-white">Passenger Experience Log</h3>
      <div className="relative mx-auto mt-6 max-w-xl overflow-hidden rounded-2xl border border-white/10 bg-white/5" data-testid="testimonial-card">
        <div className="relative h-40">
          <img src={IMAGES.proof} alt="Family luggage loaded smoothly into an executive car boot" loading="lazy" className="absolute inset-0 h-full w-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0e1628] to-transparent"></div>
        </div>
        <div className="p-8 pt-4">
          <p className="mb-4 text-sm italic text-slate-300" data-testid="testimonial-text">
            "Flight was delayed 90 minutes into Leeds Bradford from Malaga. Driver was already waiting at the arrivals barrier with a trolley."
          </p>
          <span className="font-mono-lbl text-xs uppercase text-[#38bdf8]" data-testid="testimonial-author">H. Davies &middot; Harrogate Family Holiday</span>
        </div>
      </div>
    </div>
  </section>
);
